import { useMemo } from 'react';
import useFeatureFlag from '@scentregroup/shared/hooks/use-feature-flag';
import { FeatureFlagName } from '@scentregroup/shared/feature-flags';
import { createAutocompleteMyType } from '../types';
import useReshape from './use-reshape';
import useGetSources from './use-get-sources';
import useSyncState from './use-sync-state';
export default function useAutocomplete(clients, context, onSubmit) {
  const disableLiveSearch = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_DISABLE_LIVE_SEARCH);
  let getSources = useGetSources(clients, context);
  if (disableLiveSearch) {
    getSources = () => [];
  }
  const reshape = useReshape(context);
  const {
    autocompleteState,
    onStateChange,
    resetState
  } = useSyncState();
  const autocomplete = useMemo(() => createAutocompleteMyType({
    getSources,
    reshape,
    onStateChange,
    onSubmit,
    openOnFocus: true
  }), [getSources, reshape, onStateChange, onSubmit]);
  return {
    autocomplete,
    autocompleteState,
    resetState
  };
}